export default __webpack_public_path__ + "static/media/14 ProfessionalDetails – 1.09e4fb22.png";